import { Chart, Charts } from "../../../duck";
import { HEADER_LENGTH } from "./constants";

export const getHeader = (selection: Charts, currentChart: Chart) => {
  const currentToothIndex = selection.findIndex(
    chart => chart.tooth === currentChart.tooth
  );
  const isLastVisibleToothSelected = currentToothIndex >= HEADER_LENGTH - 1;

  const begin = isLastVisibleToothSelected
    ? currentToothIndex + 1 - HEADER_LENGTH
    : 0;
  const end = isLastVisibleToothSelected
    ? currentToothIndex + 1
    : HEADER_LENGTH;
  return selection.map(chart => chart.tooth).slice(begin, end);
};
